import { Slider } from "antd";
import styled from "styled-components";
import { colors } from "src/theme/colors";
import { withAlpha } from "src/theme/ui";

/**
 * The coarse control on a money or duration field.
 *
 * Restyled off the tenant's primary ramp and onto the neutral one plus the
 * accent, for the reason the rest of this pass keeps running into:
 * `primary[15]` and `primary[25]` are full periwinkles on this tenant, not
 * tints, so a rail meant to recede was as loud as the handle riding on it.
 *
 * The handle is a solid accent disc with a white ring rather than a hollow
 * 4px outline — the product marks a single value on a line that way
 * everywhere else, and a ring on white over a pale rail nearly disappeared.
 */
const CustomSlider = styled(Slider)`
  width: 100%;
  margin: 6px 6px 6px 0;

  .ant-slider-rail {
    height: 5px;
    border-radius: 999px;
    background-color: ${colors.gray[100]};
  }

  .ant-slider-track {
    height: 5px;
    border-radius: 999px;
    background-color: ${colors.primary[500]};
  }

  .ant-slider-handle {
    width: 14px;
    height: 14px;
    margin-top: -5px;
    border: 2px solid ${colors.white};
    background-color: ${colors.primary[500]};
    box-shadow: 0 0 0 1px ${withAlpha(colors.primary[500], 0.35)};
    transition: box-shadow 0.15s ease;
  }

  &:hover .ant-slider-track,
  &.ant-slider-focused .ant-slider-track {
    background-color: ${colors.primary[500]};
  }

  &:hover .ant-slider-rail {
    background-color: ${colors.gray[200]};
  }

  .ant-slider-handle:hover,
  .ant-slider-handle:focus,
  .ant-slider-handle.ant-slider-handle-click-focused {
    border-color: ${colors.white};
    box-shadow: 0 0 0 4px ${withAlpha(colors.primary[500], 0.18)};
  }
`;

export default CustomSlider;
